import React, {useEffect} from "react";
import {Route, Switch, withRouter, Redirect} from "react-router";
import useAnalytics from "@unibuddy/machop/AnalyticsNew/hooks/useAnalytics";
import {productSpec} from "@unibuddy/machop/AnalyticsNew/constants/productSpecification";
import ErrorBoundary from "@unibuddy/machop/General/components/ErrorBoundary/ErrorBoundary";
import SuspenseLoader from "@unibuddy/machop/Shared/components/SuspenseLoader/SuspenseLoader";
import BuddiesRoutes from "./Buddies/components/BuddiesRoutes/BuddiesRoutes";
import ProtectedRoutes from "./ProtectedRoutes";

const Auth = React.lazy(() =>
    import(/* webpackChunkName: "auth" */ "./Auth/containers/Auth/Auth"),
);

export default withRouter(function AppRoutes(props) {
    const {events} = useAnalytics();
    useEffect(() => {
        events.productOpened({name: productSpec.ucas.NAME});
    }, []); // eslint-disable-line
    if (props.location.pathname === "/") {
        return <Redirect to="/buddies" />;
    }
    return (
        <div className="App__body">
            <SuspenseLoader>
                <ErrorBoundary key={props.location.pathname}>
                    <Switch>
                        <Route path="/auth" render={p => <Auth {...p} />} />
                        <Route path="/buddies" render={() => <BuddiesRoutes />} />
                        <Route component={ProtectedRoutes} />
                    </Switch>
                </ErrorBoundary>
            </SuspenseLoader>
        </div>
    );
});
